/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ImportTaskStatus = {
    Pending: 'Pending',
    Processing: 'Processing',
    Completed: 'Completed',
    Failed: 'Failed'
} as const;
export type ImportTaskStatus = typeof ImportTaskStatus[keyof typeof ImportTaskStatus];


export function instanceOfImportTaskStatus(value: any): boolean {
    for (const key in ImportTaskStatus) {
        if (Object.prototype.hasOwnProperty.call(ImportTaskStatus, key)) {
            if (ImportTaskStatus[key as keyof typeof ImportTaskStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ImportTaskStatusFromJSON(json: any): ImportTaskStatus {
    return ImportTaskStatusFromJSONTyped(json, false);
}

export function ImportTaskStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportTaskStatus {
    return json as ImportTaskStatus;
}

export function ImportTaskStatusToJSON(value?: ImportTaskStatus | null): any {
    return value as any;
}

export function ImportTaskStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): ImportTaskStatus {
    return value as ImportTaskStatus;
}

